import Ajax from '../common/ajax'

export default {
  model: 'batchRecord',
  getPage (queryParam) {
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/pageLog`, queryParam)
  },
  getPageDetail (queryParam) {
    return Ajax.post(`/api/gradeOrganization/v1/examImport/pageExam`, queryParam)
  },
  importExamList (data) {
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/importExamList`, data)
  },
  cleanBatch (data) {
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/cleanBatchRecord`, data)
  }
}
